import { Injectable } from '@angular/core';

import { BaseEditService, HttpService, NotificationService } from '../../../../tms-shared';
import { SupplierAddress, SupplierAddressEdit } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class SupplierAddressService extends BaseEditService<SupplierAddress, SupplierAddressEdit> {
  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('SupplierAddress', $localize`Supplier Address`, httpService, notificationService);
  }
}
